// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import '../../shared/shell/strings'

export const Route = createFileRoute('/platform/flags')({
  staticData: { screenId: 'ConsoleFlagsScreen', access: 'platform.flag.manage' },
  component: ConsoleFlagsScreen,
})

function ConsoleFlagsScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid="ConsoleFlagsScreen">
      <PageHeader title={t('shell.nav.flags')} titleTestId="consoleFlags_titleValue" />
    </main>
  )
}
